import React, { useState, useMemo, useContext, useEffect } from 'react'
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Modal, message, Button, Select, Popover } from 'antd'
import { SearchOutlined, SyncOutlined } from '@ant-design/icons'
import styles from './vinDomain.module.scss'
import accountApi from '@/api/accountApi'
import vinApi from '@/api/epcApi'
import { strEncrypt, getDecryptParams } from '@/utils/utils'
import VinInput from '@/components/VinInput'
import MainContext from '@/stores/stores'
import { Supplement } from '@/pages/Mine/Company'
import orderApi from '@/api/orderApi'
import Carsearch from '@/pages/Carsearch'
import { useAliveController } from 'react-activation'

const VinDomain: React.FC<any> = (props) => {
  const intl = useIntl()
  const lang = localStorage.getItem('lang') || 'zh'
  const token = localStorage.getItem("token") ? localStorage.getItem("token") : ''
  const navigate = useNavigate()
  const { refreshScope, clear, dropScope, drop, refresh  } = useAliveController()
  const { pathname } = useLocation()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { isWomala, host, pageType, open_new, colorPrimary, fontColorPrimary } = commonStore
  const { vinKeyword = '', info = {} } = props
  const [searchParams, setSearchParams] = useSearchParams()
  let params = searchParams.get('params')
  const [keyword, setKeyword] = useState<string>('')
  const [vinInfo, setVinInfo] = useState<any>({})
  const [carInfo, setCarInfo] = useState<any>({})
  const [brandList, setBrandList] = useState<any[]>([])
  const [searchKey, setSearchKey] = useState<string>('')
  const [modelList, setModelList] = useState<any[]>([])
  const [yearList, setYearList] = useState<any[]>([])
  const [yearLoading, setYearLoading] = useState<boolean>(false)
  const [brandOpen, setBrandOpen] = useState<boolean>(false)
  const [supplementOpen, setSupplementOpen] = useState<boolean>(false)
  const [companyInfo, setCompanyInfo] = useState<any>({})
  const [moreVinShow, setMoreVinShow] = useState<boolean>(false)
  const [moreVinList, setMoreVinList] = useState<any[]>([])
  const [freeCjhList, setFreeCjhList] = useState<any[]>([])
  const [yearInfo, setYearInfo] = useState<any>({})
  /* useEffect(() => {
    getBrandList()
    // getFreeCjhList()
    // if(localStorage.getItem('token')) {
    //   getUserInfo()
    // }
  }, []) */
  useEffect(() => {
    let _brandList = JSON.parse(JSON.stringify(commonStore.brandList))
    setBrandList(_brandList)
  }, [commonStore.brandList])
  useEffect(() => {
    let _freeCjhList = JSON.parse(JSON.stringify(commonStore.freeCjhList))
    if(_freeCjhList.length) {
      setFreeCjhList(_freeCjhList)
    }
  }, [commonStore.freeCjhList])
  /* useEffect(() => {
    if(commonStore.userInfo && commonStore.userInfo.repair_shop_id) {
      getCompanyInfo()
    }
  }, [commonStore.userInfo]) */
  useEffect(() => {
    if(vinKeyword) {
      setKeyword(vinKeyword)
    }
  }, [vinKeyword])
  useEffect(() => {
    let _info = JSON.stringify(info)
    if(_info !== '{}') {
      if(info.vin || info.en_plate) {
        setVinInfo(info)
        setCarInfo({})
      }else {
        setCarInfo(info)
        setVinInfo({})
        setKeyword('')
      }
    }else {
      setVinInfo({})
      setCarInfo({})
      setKeyword('')
    }
  }, [info])
  useEffect(() => {
    // if((!info.vin && !info.en_plate) && info.year && brandList.length) {
    if((!info.vin && !info.en_plate) && brandList.length) {
      let index = brandList.findIndex((ele: any) => ele.brand_name === info.brand && ele.brandCode === info.brandCode)
      if(index > -1) {
        let item = brandList[index]
        let brandOption = {
          label: item.brand_name,
          value: item.brand_name,
          key: item.key,
          ...item
        }
        setYearLoading(true)
        accountApi.modelSelect({
          key: brandOption.key,
        }).then((res: any) => {
          setYearLoading(false)
          if(res.code === 1) {
            setYearList(res.data)
            setYearInfo({
              title: res.fields && res.fields.values ? res.fields.values : '',
              key: res.fields && res.fields.key ? res.fields.key : '',
              next: res.next ? res.next : {},
              next_merge_list: []
            })
            // setModelList(res.data)
          }
        })
      } 
    }
  }, [info, brandList])
  const vinBrandImg = useMemo(() => {
    if(vinInfo.brand) {
      let index = brandList.findIndex((ele: any) => ele.brand_name === vinInfo.brand)
      if(index !== -1) {
        let brand = brandList[index]
        return brand.img
      }else {
        return ''
      }
    }else {
      return ''
    }
  }, [brandList, vinInfo])
  const getBrandList = () => {
    accountApi.getSelectBrandList().then((res: any) => {
      if(res.code === 1) {
        let _brandList: any = []
        res.data.cars_brands.all_brands.brands.forEach((code: any) => {
          code.brands.forEach((item: any) => {
            _brandList.push({
              ...item,
              img: item.brand_img
            })
          })
        })
        setBrandList(_brandList)
      }
    })
  }
  const getCompanyInfo = (userInfo: any) => {
    orderApi.getCompanyInfo({
      repair_shop_id: userInfo && userInfo.repair_shop_id ? userInfo.repair_shop_id : '',
    }).then((res: any) => {
      if(res.code === 1) {
        setCommonStore({
          type: 'companyInfo',
          value: res.data
        })
      }
    })
  }
  const getUserInfo = () => {
    accountApi.getUserInfo().then((res: any) => {
      if(res.code === 1) {
        res.data.company = res.data.reg_company_name
        setCommonStore({value: res.data, type: 'userInfo'})
        getCompanyInfo(res.data)
      }
    })
  }

  const resetCarInfo = () => {
    setCarInfo({})
    if(commonStore.pageType === '6' && pathname === '/cjh') {
      // setOeKeyword('')
      let params1 = searchParams.get('params')
      if(params1) {
        let paramsObj = getDecryptParams(params1)
        if(paramsObj.partKeyword && !paramsObj.vin && !paramsObj.en_plate) {
          toOePage(paramsObj.partKeyword)
        }else if(!paramsObj.vin && !paramsObj.en_plate && paramsObj.brand) {
          setSearchParams({
            params: ''
          })
        }
      }else {
        setSearchParams({
          params: ''
        })
      }
    }else {
      setSearchParams({
        params: ''
      })
    }
  }
  const getHistory = () => {
    vinApi.getHistory({
      page: 1,
      size: 10,
      query_type: 'vin_query,oe_query,en_plate'
    }).then((res: any) => {
      if(res.code === 1) {
        let _data = res.data && res.data.data ? res.data.data : []
        _data.forEach((item: any) => {
          if(item.query_type === 'vin_query') {
            const k = item.keyword.split(',')
            item.vin = k[0]
            item.title = k[1]
            item.carsinfo = k[1]
          }
          if(item.query_type === 'vin') {
            const k = item.keyword.split('\n')
            item.vin = k[0]
            item.title = k[1]
            item.carsinfo = k[1]
          }
        })
        _data = _data.filter((ele: any) => ele.query_type !== 'vin')
        setCommonStore({
          type: 'searchHistory', 
          value: _data
        })
      }
    })
  }
  const toOePage = (val: string) => {
    let _oeList = val.split(',').join(',')
    let _searchParams = strEncrypt({
      oeList: _oeList,
      partKeyword: val.split(',') && val.split(',')[0] ? val.split(',')[0] : ''
    })
    vinApi.setHistory({
      brandCode: '',
      keyword: _oeList,
      query_type: 'oe_query'
    }).then((res2: any) => {
      if(res2.code === 1) {
        getHistory()
      }
    })
    try {
      clear()
    }catch(err: any) {
      
    }
    setTimeout(() => {
      navigate(`/oe?params=${_searchParams}&oekey=${new Date().getTime()}`)
    },100)
  }
  const brandChange = (value: string, option: any) => {
    if(!token) {
      message.warning(intl.formatMessage({id: '请先登录'}))
      navigate('/login')
      return false
    }
    let activeBrand = JSON.parse(JSON.stringify(option))
    delete activeBrand.label
    delete activeBrand.value
    setCarInfo({
      brand: activeBrand.brand_name,
      brand_logo: activeBrand.brand_img,
      brand_img: activeBrand.brand_img,
      brandCode: activeBrand.brandCode,
    }); 
    setSearchKey(option.key)
    setYearLoading(true)
    accountApi.modelSelect({
      key: option.key,
    }).then((res: any) => {
      setYearLoading(false)
      if(res.code === 1) {
        setYearList(res.data)
        setYearInfo({
          title: res.fields && res.fields.values ? res.fields.values : '',
          key: res.fields && res.fields.key ? res.fields.key : '',
          next: res.next ? res.next : {},
          next_merge_list: []
        })
        // setModelList(res.data)
      }
      if(res.code === 1001) {
        setSupplementOpen(true)
      }
      if(res.code === 1004) {
        Modal.info({
          title: intl.formatMessage({ id: '正在等待所在公司的审核！' }),
          content: intl.formatMessage({ id: '审核通过后可获得更多商品查询次数' }),
          okText: intl.formatMessage({ id: '知道了' }),
          onOk: () => {

          }
        })
      }
    })
  }
  const freeCjhClick = (item: any) => {
    setKeyword(item.vin)
    let _title: any[] = []
    // let titleKey = ['brand', 'manufacturers', 'models', 'chassis_code', 'produced_year', 'displacement', 'engine_model', 'transmission_description', 'drive_mode', 'fuel_type']
    let titleKey = ['brand', 'manufacturers', 'produced_year', 'models', 'chassis_code', 'displacement', 'engine_model', 'transmission_description', 'drive_mode', 'fuel_type']
    titleKey.forEach((ele: string) => {
      if(item[ele]) {
        _title.push(item[ele])
      }
    })
    let brandCode = ''
    let brand_img = ''
    if(item.brand) {
      let index = brandList.findIndex((ele: any) => ele.brand_name === item.brand)
      if(index !== -1) {
        let brand = brandList[index]
        brandCode = brand.brandCode
        brand_img = brand.brand_img
      }
    }
    item = {
      ...item,
      market_name: _title.join(">"),
      brandCode,
      brand_img,
      brand_logo: brand_img,
    }
    setCarInfo({})
    if(localStorage.getItem('token') && (!localStorage.getItem('tourist_user'))) {
      vinApi.setHistory({
        brandCode: brandCode,
        query_type: 'vin_query',
        keyword: `${item.vin},${item.brand}-${item.manufacturers}-${item.models}-${item.produced_year}`
      }).then((res2: any) => {
        if(res2.code === 1) {
          getHistory()
        }
      })
    }
    if(params) {
      let paramsObj = getDecryptParams(params)
      if(paramsObj.partKeyword) {
        item.partKeyword = paramsObj.partKeyword
      }
      if(paramsObj.class) {
        item.class = paramsObj.class
      }
      if(paramsObj.tags) {
        item.tags = paramsObj.tags
      }
    }
    try {
      clear()
    }catch(err: any) {
      
    }
    let _searchParams = strEncrypt(item)
    setTimeout(() => {
      navigate(`/cjh?params=${_searchParams}&vinkey=${Math.random()}`)
    }, 500)
  }
  const vinItemClick = (item: any) => {
    let _vinInfo = {
      ...item,
      vin: keyword
    }
    let _title: any[] = []
    // let titleKey = ['brand', 'manufacturers', 'models', 'chassis_code', 'produced_year', 'displacement', 'engine_model', 'transmission_description', 'drive_mode', 'fuel_type']
    let titleKey = ['brand', 'manufacturers', 'produced_year', 'models', 'chassis_code', 'displacement', 'engine_model', 'transmission_description', 'drive_mode', 'fuel_type']
    titleKey.forEach((ele: string) => {
      if(item[ele]) {
        _title.push(item[ele])
      }
    })
    let brandCode = ''
    let brand_img = ''
    if(_vinInfo.brand) {
      let index = brandList.findIndex((ele: any) => ele.brand_name === _vinInfo.brand)
      if(index !== -1) {
        let brand = brandList[index]
        brandCode = brand.brandCode
        brand_img = brand.brand_img
      }
    }
    _vinInfo = {
      ..._vinInfo,
      market_name: _title.join(">"),
      brandCode,
      brand_img,
      brand_logo: brand_img,
    }
    setVinInfo(_vinInfo)
    if(params) {
      let paramsObj = getDecryptParams(params)
      if(paramsObj.partKeyword) {
        _vinInfo.partKeyword = paramsObj.partKeyword
      }
      if(paramsObj.class) {
        _vinInfo.class = paramsObj.class
      }
      if(paramsObj.tags) {
        _vinInfo.tags = paramsObj.tags
      }
    }
    try {
      clear()
    }catch(err: any) {
      
    }
    setMoreVinShow(false)
    let _searchParams = strEncrypt(_vinInfo)
    setTimeout(() => {
      navigate(`/cjh?params=${_searchParams}&vinkey=${Math.random()}`)
    }, 500)
  }
  const freeVinContent = () => {
    return (
      <div className={styles['free-list']}>
        {
          freeCjhList.map((item: any, index: number) => {
            return (
              <div key={index} className={styles['free-cjh-item']} onClick={() => freeCjhClick(item)}>
                <span className={styles['vin']}>{item.vin}</span>
                <span className={styles['title']}>{item.title}</span>
              </div>
            )
          })
        }
      </div>
    )
  }
  const otherValue = useMemo(() => {
    let key = 'models'
    let value = carInfo[key] ? carInfo[key] : ''
    if(yearInfo.next && yearInfo.next.key) {
      key = yearInfo.next.key
      value = carInfo[key] ? carInfo[key] : ''
      if(yearInfo.next_merge_list && yearInfo.next_merge_list.length > 1) {
        let otherKey = yearInfo.merge_list[1]
        if(carInfo[otherKey]) {
          value = value + '(' + carInfo[otherKey] + ')'
        }
      }
    }
    return value
  }, [yearInfo, carInfo])
  return (
    <>
      <div className={styles['domain-lf']}>
        <div className='flex-b-c'>
          <span className={styles['search-title']}>{intl.formatMessage({id: '车型查询'})}</span>
          <span className={styles['reset-btn']} onClick={() => resetCarInfo()}>
            <SyncOutlined style={{fontSize: 14, color: '#096BED', marginRight: 5}} />
            {intl.formatMessage({id: '重置'})}
          </span>
        </div>
        <div style={{marginTop: 6}}>
          <Select
            style={{height: 36, width: '100%'}}
            showSearch
            placeholder={intl.formatMessage({id: '选择品牌'})}
            value={carInfo.brand || undefined}
            options={
            brandList.map((item: any) => {
              return {
                  label: item.brand_name,
                  value: item.brand_name,
                  key: item.key,
                  ...item
                }
              })
            }
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            onChange={brandChange}
          />
        </div>
        <div className='mt10'>
          <Select
            style={{height: 36, width: '100%'}}
            loading={yearLoading}
            placeholder={yearInfo.title ? intl.formatMessage({id: '选择'}) + yearInfo.title : intl.formatMessage({id: '选择'})}
            options={
              yearList.map((item: any) => {
                return {
                  label: item.show_fileds,
                  value: item[yearInfo.key],
                  key: item.key,
                  ...item
                }
              })
            }
            value={carInfo[yearInfo.key]}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            // onClick={() => setBrandOpen(true)}
            onChange={
              (value: any, option: any) => {
                setCarInfo({ ...carInfo, [yearInfo.key]: option.value })
                setBrandOpen(true)
              }
            }
          />
          {/* <Select
            style={{height: 36, width: '100%'}}
            placeholder={intl.formatMessage({id: '选择车型'})}
            options={
              modelList.map((item: any) => {
                return {
                  label: item.show_fileds,
                  value: item.models,
                  key: item.key,
                  ...item
                }
              })
            }
            value={carInfo.models}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            // onClick={() => setBrandOpen(true)}
            onChange={
              (value: any, option: any) => {
                setCarInfo({ ...carInfo, models: option.value, chassis_code: option.chassis_code ? option.chassis_code : '' })
                setBrandOpen(true)
              }
            }
          /> */}
        </div>
        <div className='mt10'>
          <Select
            style={{height: 36, width: '100%'}}
            placeholder={intl.formatMessage({id: '选择其它属性'})}
            value={otherValue ? otherValue : undefined}
            onClick={() => setBrandOpen(true)}
          />
        </div>
        <div className='mt10'>
          <Button type="primary" style={{height: 36, width: '100%'}} icon={<SearchOutlined/>} onClick={() => setBrandOpen(true)}>{intl.formatMessage({id: '搜索'})}</Button>
        </div>
        <div className='mt30 flex-s-c'>
          <span className={styles['search-title']}>{intl.formatMessage({id: '车架号/车牌查询'})}</span>
          {
            freeCjhList.length ? <Popover content={freeVinContent}>
              <span className={styles['free-vin'] + ' ml10'}>{intl.formatMessage({id: '体验VIN'})}</span>
            </Popover> : null
          }
        </div>
        <div className='flex-s-c' style={{marginTop: 6}}>
          <VinInput 
            isSearch={false} 
            placeholder={intl.formatMessage({id: '请输入车架号/车牌搜索'})} 
            style={{height: 36, width: 226}}
            cameraButtonStyle={{top: '9px', right: lang === 'ara' ? 'unset' : '90px', left: lang === 'ara' ? '90px' : 'unset'}}
            value={keyword}
            enterButtonStyle={{height: 36, width: 70, marginLeft: lang === 'ara' ? 0 : 10, marginRight: lang === 'ara' ? 10 : 0}}
            enterButtonText={intl.formatMessage({id: '搜索'})}
          />
        </div>
        {
          vinInfo.vin || vinInfo.en_plate ? <div className={styles['vin-info-1'] + ' mt15'}>
            <div className={styles['logo-wrap']}>
              <img src={vinBrandImg} alt="" />
            </div>
            <div className={styles['market-name']}>
              <span>{vinInfo.market_name}{moreVinShow ? '>' : ''}</span>
              {
                moreVinShow ? <span style={{color: colorPrimary, cursor: 'pointer', textDecoration: 'underline', marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}}>{intl.formatMessage({id: '选择车型'})}</span> : null
              }
            </div>
            
          </div> : null
        }
        {
          carInfo.brand ? <div className={styles['vin-info-1'] + ' mt15'}>
            <div className={styles['logo-wrap']}>
              <img src={carInfo.brand_img} alt="" />
            </div>
            <div className={styles['market-name']}>
              <span>{carInfo.market_name}</span>
              <span style={{color: colorPrimary, cursor: 'pointer', textDecoration: 'underline', marginLeft: lang === 'ara' ? 0 : 5, marginRight: lang === 'ara' ? 5 : 0}} onClick={() => setBrandOpen(true)}>{intl.formatMessage({id: '选择车型'})}</span>
            </div>
          </div> : null
        }
      </div>
      {
        supplementOpen ? (
          <Supplement
            companyInfo={commonStore.companyInfo}
            onCancel={() => setSupplementOpen(false)}
            onConfirm={() => {getUserInfo()}}
          />
        ): null
      }
      <Modal
        open={moreVinShow}
        title={intl.formatMessage({id: '选择要查询的内容'})}
        footer={null}
        maskClosable={false}
        onCancel={() => setMoreVinShow(false)}
      >
        <div className={styles['more-vin']}>
          {
            moreVinList.map((item: any) => {
              return (
                <div className={styles["item"]} key={item.code} onClick={() => vinItemClick(item)}>
                  <div className={styles["txt"]}>{item.manufacturers} </div>
                  <div className={styles["first"]}>
                    <div style={{marginRight: lang === 'ara' ? 0 : 20, marginLeft: lang === 'ara' ? 20 : 0}}>
                      <label>{intl.formatMessage({id: '年份'})}：</label>
                      <span>{item.produced_year}</span>
                    </div>
                    <div>
                      <label>{intl.formatMessage({id: '排量'})}：</label>
                      <span>{item.displacement}</span>
                    </div>
                  </div>
                  <div className={styles["other"]}>
                    <label>{intl.formatMessage({id: '变速箱'})}：</label>
                    <span>{item.transmission_description}</span>
                  </div>
                  <div className={styles["other"]}>
                    <label>{intl.formatMessage({id: '底盘'})}/{intl.formatMessage({id: '驱动'})}：</label>
                    <span>{item.drive_mode}</span>
                  </div>
                  <div className={styles["other"]}>
                    <label>{intl.formatMessage({id: '发动机型号'})}：</label>
                    <span>{item.engine_model}</span>
                  </div>
                </div>
              )
            })
          }
        </div>
      </Modal>
      <Modal
        open={brandOpen}
        onCancel={() => setBrandOpen(false)}
        footer={null}
        width={1200}
        wrapClassName={styles['car-brand-search']}
      >
        <Carsearch
          from='vinInput'
          carInfo={carInfo}
          setCarInfo={(data: any) => {setCarInfo(data); setVinInfo({});}}
          setOpen={setBrandOpen}
        />
      </Modal>
    </>
  )
}
export default VinDomain